export const debugMessage = (msg: string) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(msg)
  }
}